import { forwardRef } from 'react';
import { NumericalInput } from './NumericalInput';
import { NATIVE_CURRENCY_DECIMALS } from '@silo/types';

type AmountInputProps = {
  inputVal: string;
  setInputVal: (value: string) => void;
  decimals?: number;
} & Omit<React.HTMLProps<HTMLInputElement>, 'ref' | 'onChange' | 'as' | 'value'>;

export const AmountInput = forwardRef<HTMLInputElement, AmountInputProps>(
  ({ inputVal, setInputVal, decimals = NATIVE_CURRENCY_DECIMALS, disabled, ...rest }, ref) => {
    const disabledClasses = disabled ? 'opacity-70' : '';

    /**
     * TODO: consolidate this with NumericalInput
     */
    return (
      <NumericalInput
        className={`w-full bg-transparent font-mono text-base sm:text-xl font-medium text-white ${disabledClasses}`}
        id="deposit-amount-input"
        value={inputVal}
        onUserInput={(val) => setInputVal(val)}
        ref={ref}
        decimals={decimals}
        data-cy="form-input"
        disabled={disabled}
        {...rest}
      />
    );
  }
);
